import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgPlusIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 3V13", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 8L3 8", stroke: "currentColor", strokeLinecap: "round" }));
});
export default SvgPlusIcon;
